import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError } from "rxjs";
import { SelectList, SelectListParams } from "../selectLists/selectList";
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';

@Injectable({
    providedIn: 'root'
  })
  export class SelectListsApiService {
    private apiUrl = '/api/selectLists';
    

    constructor(private httpClient: HttpClient, private translation: L10nTranslationService) { }
    
    /**
     * Metodo que devuelve los valores de un selector (filtrados por los filtros recibidos)
     * @param options Parametros de busqueda del selector
     * @returns Lista del selector filtrado
    */
    public async requestSelectList(options?: SelectListParams ): Promise<SelectList[]> {
        let params = new HttpParams();
        if (options) {
          Object.keys(options).forEach(function (key) {
            params = params.append(key, options[key as keyof typeof options]);
          });
        }
        
        let results : SelectList[];
        await this.httpClient.get<{ results: SelectList[]}>(`${this.apiUrl}/get`, { params }).toPromise()
        .then(res => {
          results = res.results;
        });

        return results;
    }
    
    /**
     * Método que devuelve los valores de un selector traducidos (filtrados por los filtros recibidos)
     * @param options Parametros de busqueda del selector
     * @param fieldSelectList nombre del campo del selector (para las traducciones)
     * @param filters Lista de valores que se pueden tener en el selector (valores que vienen de configuración externa a la bbdd)
     * @returns Lista del selector filtrado
    */
    public async requestSelectListWithFilters(options?: SelectListParams, fieldSelectList?: string, filters?: number[] ): Promise<SelectList[]> {
      let params = new HttpParams();
      if (options) {
        Object.keys(options).forEach(function (key) {
          params = params.append(key, options[key as keyof typeof options]);
        });
      }
      
      let results : SelectList[];
      await this.httpClient.get<{ results: SelectList[]}>(`${this.apiUrl}/get`, { params }).toPromise()
      .then(res => {
        results = [];
        if (filters && filters.length > 0){
          if(res.results && res.results.length > 0){
            filters.forEach(f => {
              if(!res.results.map(x => Number.parseInt(x.value)).includes(f)){
                results.push({value: f.toString(), text: this.translation.translate(fieldSelectList + f)});
              }
            });
          }else{
            filters.forEach(f => {
              results.push({value: f.toString(), text: this.translation.translate(fieldSelectList + f)});
            });
          }
        } else if(res.results && res.results.length > 0) {
          res.results.forEach(r => {
            var value = r.value && r.value.length>1 ? r.value[0] : 0;
            results.push({value: value.toString(), text: this.translation.translate(fieldSelectList + value)});
          });
        }
      });

      return results;
  }

  }